export default "__VITE_ASSET__C8kc89Hg__"